const useForm = () => {
  const handleScrollToError = (errors) => {
    if (errors && Object.keys(errors)?.length) {
      const firstError = document.querySelector(`#error_${Object.keys(errors)[0]}`);

      if (firstError?.offsetTop && window.innerHeight) {
        window.scrollTo(0, firstError.offsetTop - (window.innerHeight / 2));
      }
    }
  };

  return {
    handleScrollToError,
  };
};

export default useForm;
